import { render, staticRenderFns } from "./CompanyFooter.vue?vue&type=template&id=f0e827ee&"
import script from "./CompanyFooter.vue?vue&type=script&lang=js&"
export * from "./CompanyFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports